import { MESSAGE_TYPOGRAPHY } from "@productlane/lib/src/message-typography"

export { MESSAGE_TYPOGRAPHY }

/**
 * Class that opts a rendered body into the message metrics. Bodies we composed
 * ourselves carry it; a sender's own HTML does not, so their mail client's
 * spacing survives.
 */
export const MESSAGE_BODY_CLASS = "pl-message-body"

const t = MESSAGE_TYPOGRAPHY
const scope = `.${MESSAGE_BODY_CLASS}`

/** Plain-CSS form of the message metrics, for renderers Tailwind cannot reach. */
export const MESSAGE_BODY_CSS = `
${scope} {
	font-size: ${t.fontSize};
	line-height: ${t.lineHeight};
}
${scope} p {
	margin: ${t.paragraphMargin};
}
${scope} p:empty::before {
	content: "";
	display: inline-block;
}
${scope} h1 { font-size: ${t.headingSize.h1}; }
${scope} h2 { font-size: ${t.headingSize.h2}; }
${scope} h3 { font-size: ${t.headingSize.h3}; }
${scope} h4,
${scope} h5,
${scope} h6 { font-size: ${t.headingSize.h4}; }
${scope} h1,
${scope} h2,
${scope} h3,
${scope} h4,
${scope} h5,
${scope} h6 {
	margin: ${t.headingMargin};
	font-weight: ${t.headingWeight};
	line-height: ${t.headingLineHeight};
}
${scope} ul,
${scope} ol {
	margin: ${t.listMargin};
	padding-left: ${t.listIndent};
}
${scope} li {
	margin: ${t.listItemMargin};
}
${scope} blockquote {
	margin: ${t.blockquoteMargin};
	padding-left: ${t.blockquotePadding};
}
${scope} hr {
	margin: ${t.ruleMargin};
}
${scope} pre,
${scope} code {
	font-size: ${t.codeFontSize};
}
`
